import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';
import { Image as SemanticImage } from 'semantic-ui-react';
import exerciseOutdoorsSrc from 'assets/media/eden/my-workspace/exercise-outdoors.jpeg';
import styles from '../styles.module.scss';

export const ExerciseOutdoors = () => (
  <>
    <SemanticImage
      src={exerciseOutdoorsSrc}
      alt="Exercise outdoors"
      className={styles.image}
    />

    <Text size={16}>
      <FormattedMessage
        id="exerciseOutdoorsDescription"
        values={{
          bold: (...chunks) => (
            <Text
              size={16}
              element="span"
              bold
            >
              {chunks}
            </Text>
          ),
        }}
      />
    </Text>
  </>
);
